import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/suggestion.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleSuggestionReviewRejectedEvent } from './Types'

interface Props extends ActivityEventPosition {
  event: ArticleSuggestionReviewRejectedEvent
}

const ArticleSuggestionReviewRejected = ({ event, ...props }: Props) => {
  const {
    user,
    data: { message, suggester },
    timestamp,
  } = event

  return (
    <BaseActivityEvent
      {...props}
      icon={<Icon />}
      timestamp={timestamp}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous user'} userId={user?.id} /> sent back changes to{' '}
          <Actor displayName={suggester.display_name || 'Anonymous user'} userId={suggester?.id} />
          's suggestions
        </>
      }
      message={message}
    />
  )
}

export { ArticleSuggestionReviewRejected }
